<template>
  <div class="entryInfoBody">
    
    <div class="entryInfoMain" v-show="!codeShow||!authCompletedShow">
      <h2 class="title">证书持有人实名认证</h2>
      <div class="infoMainBody">
        <div class="infoArea">
          <el-form :model="infoForm" :rules="rules" ref="infoForm" label-width="100px" label-position="left">
            <el-form-item label="证件类型" prop="identType">
              <el-select disabled v-model="infoForm.identType" placeholder="请选择证件类型" size="small" @change="setIdenType">
                <el-option v-for="item in identType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="姓名" prop="name">
              <el-input v-model="infoForm.name" disabled size="small" placeholder="请输入姓名" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item v-if="infoForm.identType == 0" label="证件号码" prop="identNo">
              <el-input v-model="infoForm.identNo" disabled size="small" placeholder="请输入证件号码" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item v-if="infoForm.identType != 0" label="证件号码" prop="identNo">
              <el-input v-model="infoForm.identNo" disabled size="small" placeholder="请输入证件号码" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item v-if="infoForm.identType == 0" label="认证方式" prop="mode">
              <el-select v-model="infoForm.mode" placeholder="请选择认证方式" size="small" @change="setMode">
                <el-option v-for="( item, index) in authMode" :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <p v-if="infoForm.mode==1">与银行开户预留身份信息比对验证，请确保手机号为银行卡预留手机号</p>
              <p v-if="infoForm.mode==2">根据页面提示完成指定动作后进行人脸识别，并与公安部预留人像进行 比对认证；使用此认证方式，视为您同意“豸信CA”采集您的人脸信息 用于实名认证</p>
            </el-form-item>
            <el-form-item v-if="infoForm.mode == 1" label="银行卡号" prop="bankCardNo">
              <el-input v-model="infoForm.bankCardNo" size="small" placeholder="请输入银行卡号" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item v-if="infoForm.mode == 1|| infoForm.mode == 0" label="手机号" prop="mobile">
              <el-input v-model="infoForm.mobile" disabled size="small" placeholder="请输入手机号" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item v-if="infoForm.mode == 1 || infoForm.mode == 0" label="验证码" prop="smsCode">
              <el-input class="verificationCode" v-model="infoForm.smsCode" size="small" placeholder="请输入验证码" maxlength="6"></el-input>
              <el-button class="codeBtn" plain size="small" :disabled="countDown>0" @click="getCode">{{countDown>0?`重新获取(${countDown})`:'获取验证码'}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="agreementsBottom">
        <p>
          <el-checkbox v-model="checked"></el-checkbox>我已知悉上述内容并同意<el-button type="text" @click="goRouter('serviceAgreement')">《认证服务协议》</el-button>
          <!-- <el-button type="text" @click="goRouter()">《数字证书服务协议》</el-button> -->
          <el-button type="text" @click="goRouter('certAgreement')">《数字证书服务协议》</el-button>
          <el-button type="text" @click="goRouter('privacyPolicy')">《隐私政策》</el-button>
          <span v-if="!checked" class="checkTitle" :class="{animation:animation}">请确认并勾选协议</span>
        </p>
      </div>
    </div>
    <scanningCode ref="scanningCode" v-show="codeShow" :codeShow="codeShow" :flowId="flowId" :sesCode="sesCode" @sendCode="sendCode"></scanningCode>
    <authResult :verifyMsg="verifyMsg" :face="face" :faceResult="faceResult" v-show="authCompletedShow" @blockAuth="getBackStep" @blockFace="blockFace"></authResult>
  </div>
</template>

<script>
import request from '@/utils/request'
import scanningCode from './scanningCode.vue'
import authResult from './authResult.vue'
export default {
  name: 'entryInfo',
  data() {
    return {
      codeShow: false,
      authCompletedShow: false,
      animation: false,
      checked:false,
      face: false,
      faceResult: false,
      infoForm: {
        name: '',
        mode: 2,
        identType: 0,
        mobile: '',
        identNo: null
      },
      flowId: '',
      countDown: 0,
      intervals: [],
      sesCode: '',
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          // {
          //   validator: this.validName,
          //   message: '请输入正确的姓名',
          //   trigger: 'blur'
          // }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          // {
          //   message: '请输入正确的手机号码',
          //   validator: validMobile,
          //   trigger: 'blur'
          // }
        ],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        identNo: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          // {
          //   validator: this.validIDcard,
          //   message: '请输入正确的18位身份证号码',
          //   trigger: 'blur'
          // }
        ],
        mode: [{ required: true, message: '请选择认证方式', trigger: 'blur' }],
        identType: [
          { required: true, message: '请选择证件类型', trigger: 'blur' }
        ],
        bankCardNo: [
          { required: true, message: '请输入银行卡号', trigger: 'blur' }
        ]
      },
      identType: [
        {
          value: 0,
          label: '中国居民身份证'
        },
        {
          value: 1,
          label: '护照'
        },
        {
          value: 2,
          label: '港澳来往大陆通行证'
        },
        {
          value: 3,
          label: '台湾来往大陆通行证'
        }
      ],
      authMode: [],
      verifyMsg: ''
    }
  },
  create() {
   
  },
  watch: {
    // 'infoForm.mode': function (val,oldVal) {
    //   // console.log(val,oldVal)
    // }
  },
  components: {
    scanningCode,
    authResult
  },
  mounted() {
    this.clearInterval()
    this.$nextTick(() => {
      window.addEventListener('message', this.handleMessageEvent)
      // 告诉父组件准备好接收消息了
      window.parent.postMessage({
        code: 0,
        msg: '连接成功'
      }, '*')
    })
    this.$bus.$on('cgLoginShow', () =>{
      window.parent.postMessage({code: 4}, '*')
    })
  },
  updateDestory(){
    window.removeEventListener('message', this.handleMessageEvent) 
  },
  methods: {
    sendCode(item) {
      this.face = false
      window.parent.postMessage({code: -1}, '*')
      if(item.code === -1) {
        this.verifyMsg = item.msg
        this.authCompletedShow = true
      } else  if(item.code === -2) {
        this.verifyMsg = item.msg
        this.face = item.result !== 3 ? true : false
        this.authCompletedShow = true
      } else {
        window.parent.postMessage(item, '*')
        
      }
      
    },
    blockFace () {
      window.parent.postMessage({code: 2}, '*')
      this.codeShow = true
      this.authCompletedShow = false
      this.$refs.scanningCode.getCreateFaceUrl()
    },
    goRouter(val) {
      this.$router.push({ name: val })
    },
    handleMessageEvent(event) {
      // console.log(event)
      // if (event.data && event.origin === 'http://192.168.105.29:8084') {
        const data = event.data
        if (data.code === 0) {
          this.flowId = data.data.flowId
          request({
            url: data.data.longUrl,
            method: 'get',
            data: {}
          }).then(res => {
            // console.log(res)
            this.$store.commit('SET_TOKEN', 'Bearer ' + res.data.tokenVo.accessToken, res.data.tokenVo.expiresIn+ 's')
            // let flowData = res.data.redirectUrl.split('?')[1]
            
            this.redirectUrl = res.data.redirectUrl
            this.getInfo()
            window.parent.postMessage({code: 1}, '*')
          })
          
        } else if(data.code === 1) {
          if (!this.checked) {
            this.animation = true
            setTimeout(() => {
              this.animation = false
            }, 1500)
          } else {
            this.setVerify() 
          } 
        } else if(data.code === 2) {
            this.getBackStep()
          }
      // }
    },
    getBackStep() {
      this.$api.getBackStep({flowId: this.flowId})
        .then(res => {
          if(res.code !== '0') { 
              return new Promise((resolve, reject) => { reject(res) })
            }
          window.parent.postMessage({code: 1}, '*')
          this.getInfo()
        }).catch(err=>{
          if(err.code !== '302') {
            this.$alert(err.msg, '提示', {
              confirmButtonText: '好的',
              type: 'warning',
              callback: () => {
                  window.parent.postMessage({code: 4}, '*')
                }
            })
          }
        })
    },
    getInfo() {
      request({
            url: this.redirectUrl,
            method: 'get',
            data: {}
          }).then(res => {
            this.infoForm.identType = 0
            this.infoForm.identNo = res.data.certNo
            this.infoForm.name = res.data.name
            this.infoForm.mobile = res.data.mobileNo
            let authMode = res.data.availableAuthType.split(',')
            this.authMode=[]
            authMode.forEach((v) =>{
              if(v === 'PSN_BANK4_AUTHCODE') {
                this.authMode.push({
                  value: 1,
                  label: '个人银行卡认证'
                })
              }
              if(v === 'PSN_TELECOM_AUTHCODE') {
                this.authMode.push({
                  value: 0,
                  label: '实名手机号认证'
                })
                
              }
              if(v === 'PSN_FACEAUTH_BYURL') {
                this.authMode.push({
                  value: 2,
                  label: '人脸识别认证'
                })
              }
              
            })
            this.infoForm.mode = res.data.authType === 'PSN_TELECOM_AUTHCODE' ? 0: res.data.authType === 'PSN_BANK4_AUTHCODE'? 1: 2
            this.codeShow = false
            this.authCompletedShow = false
            if(res.code !== '0') { 
              return new Promise((resolve, reject) => { reject(res) })
            }
          }).catch(err => {
            if(err.code === '810404') {
              window.parent.postMessage({code: -1}, '*')
              this.$alert(err.msg, '提示', {
                confirmButtonText: '好的',
                callback: () => {
                  window.parent.postMessage({code: 4}, '*')
                }
              })
              
            } else if(err.code !== '302') {
              this.sendCode({code: -1,msg:  err.msg})
              // this.verifyMsg =  err.msg || '认证失败'
              // this.authCompletedShow = true
            }
          })
    },
    isIDcard(e) {
      const cardRule = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/
      return cardRule.test(e)
    },
    validIDcard(rule, value, callback) {
      if (rule.required && !value) {
        callback(new Error('证件号不能为空'))
      } else {
        if (this.infoForm.identType === 0) {
          if (!this.isIDcard(value) && value) {
            callback(new Error('请输入正确的证件号'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    },
    isName(s) {
      const nameRule = /^([\u4e00-\u9fa5]|·){2,30}$/
      return nameRule.test(s)
    },
    validName(rule, value, callback) {
      if (rule.required && !value) {
        callback(new Error('请输入姓名'))
      } else {
        if (this.infoForm.identType === 0) {
          if (!this.isName(value) && value) {
            callback(new Error('请输入正确的姓名'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    },
    setMode() {
      if (this.infoForm.mode == 0) {
        delete this.infoForm.bankCardNo
      } else if (this.infoForm.mode == 2) {
        this.infoForm.identType = 0
        delete this.infoForm.bankCardNo
        delete this.infoForm.smsCode
      }
    },
    setIdenType(val) {
      this.$refs.infoForm.clearValidate(['identNo'])
      this.infoForm.identNo = null
      if (val !== 0) {
        this.infoForm.mode = 1
      }
    },
    setVerify() {
      this.$refs['infoForm'].validate(valid => {
        if (valid) {
          this.infoForm.flowId = this.flowId
          delete this.infoForm.identType
          delete this.infoForm.identNo
          delete this.infoForm.name
          delete this.infoForm.mobile
          this.$api.createVerify(this.infoForm).then(res => {
            this.$set(this.infoForm, 'smsCode','')
            this.$set(this.infoForm, 'bankCardNo','')
            if(res.code !== '0') { 
              return new Promise((resolve, reject) => { reject(res) })
            }
            
            if (this.infoForm.mode == 2) {
              this.sesCode = res.data.qrCodeResponseVO.fileBytes
              this.codeShow = true
              window.parent.postMessage({code: 2}, '*')
              // this.$router.push({ name: 'scanningCode' })
            } else {
              this.verifyMsg =  res.code == 0 ? '' : res.msg
              window.parent.postMessage({
                code: 3
              }, '*')
              // this.$router.push({ name: 'authCompleted' })
            }
          }).catch(err => {
            if(err.code !== '302') {
              this.sendCode({code: -1, msg:  err.msg})
            // this.verifyMsg =  err.msg || '认证失败'
            // this.authCompletedShow = true
          }
            
          })
        }
      })
      // let data = {}
    },
    clearInterval() {
      for (let i of this.intervals) {
        clearInterval(i)
      }
    },
    getCode() {
      this.$refs.infoForm.validateField('mobile', err => {
        if (!err) {
          this.$tencentCaptcha(val => {
            this.countDown = 60
            val['flowId'] = this.flowId
            this.$api
              .getSmsCode(val)
              .then(res => {
                if (res.code && res.code !== '0') {
                  return new Promise((resolve, reject) => { reject(res)})
                }
                this.infoForm.smsToken = res.data.sms_token
                this.intervals.push(
                  setInterval(() => {
                    this.countDown--
                    if (this.countDown == 0) {
                      this.clearInterval()
                    }
                  }, 1000)
                )
              })
              .catch(err => {
                if(err.code !== '302') {
                  this.$alert(err.msg, '提示', {
                    confirmButtonText: '好的',
                    type: 'warning'
                  })
                }
                this.countDown = 0
              })
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.entryInfoBody {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 100%;
  background: #f1f3f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.entryInfoMain {
  width: 100%;
  flex: 1;
  min-height: 620px;
  margin: 0px auto 0;
  background: #fff;
  position: relative;
  .title{
    height: 50px;
    border: 1px solid #ECEFF3;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    margin-bottom: 19px;
    line-height: 50px;
    padding-left: 40px;
    position: relative;
    &::before {
      content: "";
      width: 2px;
      height: 14px;
      background: #4673fd;
      position: absolute;
      top: 19px;
      left: 32px;
    }
  }
}
.infoMainBody{
  padding: 60px 0 56px;
}
.infoArea {
  width: 520px;
  margin: 51px auto 0;
  padding-bottom: 20px;
  .el-input,
  .el-select {
    width: 408px;
  }
  p {
    width: 408px;
    padding: 8px 12px;
    margin-top: 12px;
    background: #f1f5ff;
    border-radius: 2px;
    font-size: 12px;
    color: #595959;
    line-height: 14px;
  }
  .verificationCode {
    width: 295px;
    margin-right: 8px;
  }
  .el-button.is-plain {
    background: #fff;
    border-color: #1c67f3;
    ::v-deep span {
      color: #1c67f3;
    }
    &.codeBtn.is-disabled {
      border-color: #eceff3;
      ::v-deep span {
        color: #c0c4cc !important;
      }
    }
  }
}
.agreementsBottom {
  width: 1600px;
  background: #fff;
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  margin: auto;
  padding-bottom: 40px;
  text-align: center;
  .el-checkbox {
    margin-right: 5px;
  }
  .checkTitle {
    position: absolute;
    left: 431px;
    top: -36px;
    width: 122px;
    height: 38px;
    line-height: 38px;
    font-size: 12px;
    color: #fff;
    background: #595959;
    border-radius: 4px;
    &::before {
      position: absolute;
      bottom: -6px;
      left: 58px;
      content: '';
      border-top: 6px solid #595959;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
    }
    &.animation {
      animation: shake 0.5s;
    }
  }
}
@keyframes shake {
  0%,
  100% {
    transform: translate(0);
  }
  // 25%,
  // 75% {
  //   transform: translate(0, -8px);
  // }
  50% {
    transform: translate(0, 6px);
  }
}
</style>